import { FC } from 'react';

import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import useTrls from 'hooks/translation/useTrls';

import { getUrlToBanners } from 'components/CampaignsDashboard/utils/utils';

import { setModerationFailedAlert } from 'store/models/campaignsDashboard';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'ModerationFailedAlert.title',
    description: 'ModerationFailedAlert.description',
    more: 'ModerationFailedAlert.button.more',
    cancel: 'ModerationFailedAlert.button.cancel',
};

export const ModerationFailedAlert: FC = () => {
    const statusChangeCampaignId = useSelector((state) => state.campaignsDashboard.statusChangeCampaignId);
    const isAlertVisible = useSelector((state) => state.campaignsDashboard.isModerationFailedAlertVisible);

    const dispatch = useDispatch();
    const trls = useTrls();

    const handleClose = () => dispatch(setModerationFailedAlert({ isVisible: false, campaignId: null }));

    return (
        <Alert
            visible={isAlertVisible}
            title={trls(TrlKeys.title)}
            description={trls(TrlKeys.description)}
            buttons={
                <ButtonStack stretched layout="vertical">
                    <Button
                        mode="primary"
                        style="accent"
                        size="small"
                        target="_blank"
                        Element={SPALink}
                        to={statusChangeCampaignId ? getUrlToBanners(statusChangeCampaignId) : ''}
                        data-qa={`alert-campaign-status-banners-link`}
                    >
                        {trls(TrlKeys.more)}
                    </Button>
                    <Button mode="secondary" style="accent" onClick={handleClose}>
                        {trls(TrlKeys.cancel)}
                    </Button>
                </ButtonStack>
            }
            onClose={handleClose}
        >
            <InfoCircleFilledSize24
                initialColor="tertiary"
                backgroundStyle="secondary"
                padding={12}
                borderRadius="halfHeight"
            />
        </Alert>
    );
};
